export const config = {
  title: "Jyanni's Detailing | Auto Detailing in Antelope Valley",
  meta: {
    description:
      "Jyanni's Detailing provides professional mobile auto detailing services across Antelope Valley. We specialize in interior, exterior, ceramic coatings, and more.",
    keywords: [
      "Jyanni's Detailing",
      "auto detailing Antelope Valley",
      "mobile car detailing",
      "ceramic coating Antelope Valley",
      "interior exterior detailing"
    ],
    author: "Jyanni's Detailing",
    canonicalUrl: "https://jyannisdetailing.com/",
  },
  sections: {
    header: {
      businessName: "Jyanni's Detailing",
    },
    sectionB: {
      heroTitle: "Mobile Auto Detailing Experts",
      heroSubtitle: "Serving Antelope Valley with precision and passion.",
      learnAboutText: "Request a Quote",
      phoneNumber: "6616747067",
      phoneLabel: "(661) 674-7067",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1272577182/photo/car-detailing.jpg?s=612x612&w=0&k=20&c=AmH7v05Y2Yt5rf1yTiCRYrglU9-cbIwiQgAgrq3ljnY=",
      cardData: [
        {
          title: "Interior Detailing",
          description: "Deep cleaning of carpets, seats, and all surfaces for a fresh cabin feel.",
        },
        {
          title: "Exterior Wash & Wax",
          description: "Protect your paint with our premium wash, clay bar, and wax treatments.",
        },
        {
          title: "Ceramic Coating",
          description: "Long-lasting protection with advanced ceramic technology.",
        },
      ],
      description:
        "With years of experience, Jyanni's Detailing is trusted throughout Antelope Valley for reliable, high-quality detailing services tailored to each vehicle.",
    },
    sectionC: {
      servicesTitle: "Our Detailing Services",
      servicesDescription:
        "From basic washes to complete ceramic protection, we've got your car covered.",
      cards: [
        {
          title: "Interior Detailing",
          description: "Steam cleaning, stain removal, vacuuming, and dashboard conditioning.",
          imageSrc: "https://jyannisdetailing.com/cdn/shop/files/is-this-worth-about-100-v0-ere1o73cc6mb1.jpg?v=1754458984&width=832",
          imageAlt: "Interior Detailing Service",
        },
        {
          title: "Exterior Detailing",
          description: "Premium hand wash, paint decontamination, and shine enhancement.",
          imageSrc: "https://jyannisdetailing.com/cdn/shop/files/67ef467e019de0436d66a1a0.jpg?v=1757538305&width=832",
          imageAlt: "Exterior Detailing Service",
        },
        {
          title: "Ceramic Coating",
          description: "Protect your vehicle's finish with long-term ceramic protection.",
          imageSrc: "https://jyannisdetailing.com/cdn/shop/files/BMW_Mini_Interior_Detail_-_Rhode_Island_jpg.webp?v=1757538091&width=1200",
          imageAlt: "Ceramic Coating Service",
        },
      ],
      otherServicesTitle: "Why Choose Jyanni’s?",
      otherServicesList: [
        "Mobile Service – We come to you!",
        "Flexible Appointments",
        "Eco-Friendly Products",
        "Trusted by the Community",
        "Affordable Pricing Packages",
      ],
    },
    sectionD: {
      aboutTitle: "About Jyanni's Detailing",
      aboutImage: {
        src: "https://jyannisdetailing.com/cdn/shop/files/iStock-30667048.jpg?height=596&v=1757225382",
        alt: "Jyanni's Detailing Logo",
      },
      aboutText: [
        "At Jyanni's Detailing, we treat your car like it’s our own. We bring years of detailing experience right to your driveway with a complete mobile service that’s efficient, professional, and affordable.",
        "Proudly serving the Antelope Valley region with a commitment to excellence and customer satisfaction.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Jyanni's Detailing Logo",
      businessName: "Jyanni's Detailing",
      contact: {
        phone: "6616747067",
        phoneLabel: "(661) 674-7067",
        email: "jyannisdetailing@gmail.com",
        website: "https://jyannisdetailing.com/",
        address: "Antelope Valley, CA, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Antelope Valley, CA, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d262139.14220689666!2d-118.3744569!3d34.7755702!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c27d7d191cfbb1%3A0x7a168273f7edc4e!2sAntelope%20Valley%2C%20CA!5e0!3m2!1sen!2sus!4v1694795092385!5m2!1sen!2sus",
    },    
  },
};

export default config;